import { isPastDue } from "./paymentDueDate";
export const getInvoiceStatusKey = (row, now = new Date()) => {
  if (["draft", "overdue", "awaiting", "paid", "voided"].includes(row?.registerStatus)) {
    return row.registerStatus;
  }
  const paymentStatus = String(
    row?.invoiceStatus || row?.paymentStatusLabel || ""
  )
    .trim()
    .toLowerCase();
  const activityStatus = String(row?.activityStatus || "")
    .trim()
    .toLowerCase();

  if (paymentStatus.includes("void")) return "voided";
  if (paymentStatus === "paid" || paymentStatus === "fully paid") return "paid";
  if (
    !paymentStatus.includes("partial") &&
    !(Number(row?.emailSent) > 0) &&
    (!activityStatus ||
      activityStatus === "draft" ||
      activityStatus === "pending")
  ) {
    return "draft";
  }

  return isPastDue(row?.dueDate, now) ? "overdue" : "awaiting";
};
